import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationLoaderService {
  constructor(private translate: TranslateService) {}

  loadTranslations(): Promise<void> {
    return new Promise((resolve) => {    
      const supportedLangs = ['pt', 'en', 'es', 'fr', 'nl'];

      const storedLang = localStorage.getItem('localeCode');
      const browserLang = this.translate.getBrowserLang();

      let lang = 'en';

      if (storedLang && supportedLangs.includes(storedLang)) {
        lang = storedLang;
      } else if (browserLang && supportedLangs.includes(browserLang)) {
        lang = browserLang;
      }

      this.translate.setDefaultLang('en');
  
      this.translate.use(lang).subscribe(() => {
        console.info('[i18n] initialized with:', lang);
        resolve();
      });
    });
  }
}
